import { render } from "./Financial.vue?vue&type=template&id=1638335e&scoped=true&ts=true"
import script from "./Financial.vue?vue&type=script&lang=ts"
export * from "./Financial.vue?vue&type=script&lang=ts"

import "./Financial.vue?vue&type=style&index=0&id=1638335e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1638335e"]])

export default __exports__